export const SEVERITY_CLASS_NAME_MAP = {
  critical: 'gl-text-red-800',
  high: 'gl-text-red-600',
  medium: 'gl-text-orange-400',
  low: 'gl-text-orange-300',
  info: 'gl-text-blue-400',
  unknown: 'gl-text-gray-400',
};
